'use client';
import { jsxs, jsx } from '@emotion/react/jsx-runtime';
import { Stack } from '@s7/layout';
import { CategoryLinks } from './NavigationCategoryLinks.js';
import { NavigationCategoryTitle } from './NavigationCategoryTitle.js';

var NavigationCategory = function(props) {
    var title = props.title, link = props.link, items = props.items;
    return /*#__PURE__*/ jsxs(Stack, {
        spacing: 20,
        children: [
            /*#__PURE__*/ jsx(NavigationCategoryTitle, {
                link: link,
                title: title
            }),
            items && items.length && /*#__PURE__*/ jsx(CategoryLinks, {
                items: items
            })
        ]
    });
};

export { NavigationCategory };
